var React = require('react');

function ArrowUpInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.3999 22.1704H28.5777L26.5999 19.9704L17.9999 11.6704L15.7999 11.7704L8.3999 18.6704L6.0999 20.6704L5.3999 22.1704Z","fill":"white","key":0}),React.createElement("path",{"d":"M5.5 21.6705L15 12.2704C16.1 11.1704 17.9 11.1704 19 12.2704L28.5 21.6705","stroke":"#DDDDDD","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowUpInline.defaultProps = {"width":"34","height":"35","viewBox":"0 0 34 35","fill":"none"};

module.exports = ArrowUpInline;

ArrowUpInline.default = ArrowUpInline;
